import React, { Component } from 'react';
import 'typeface-nanum-gothic';
import './App.css';
import 'normalize.css';
import 'jquery';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import Box from '../box/Box';
import Particles from 'react-particles-js';
import 'animate.css';

class App extends Component {
  componentWillMount() {
    document.getElementsByTagName('body')[0].style.background = `url('${process.env.PUBLIC_URL}/img/city-background.jpg')`;
  }

  render() {
    return (
      <div className="App">
        <div className="cisco-small-logo">
          <a href="http://www.cisco.com" target="_blank" rel="noopener noreferrer">
            <img alt="cisco-small-logo" src={`${process.env.PUBLIC_URL}/img/cisco-small.svg`} />
          </a>
        </div>
        <div className="title">
          <span>Welcome To Cisco Tools</span>
        </div>
        <div className="row row-block justify-content-center">

          <Box link={"https://wwwin.cisco.com"}>
            <img alt="employee-connection-logo" src={`${process.env.PUBLIC_URL}/img/employee-connection.png`} className="logo"/>
          </Box>
          <Box link={"http://cisco.webex.com"}>
            <img alt="webex-logo" src={`${process.env.PUBLIC_URL}/img/cisco-webex.png`} className="logo"/>
          </Box>
          <Box link={" http://directory.cisco.com/dir/"}>
            <img alt="people-directory-logo" src={`${process.env.PUBLIC_URL}/img/people-directory.png`} className="logo"/>
          </Box>
          <Box link={"http://estore.cisco.com"}>
            <img alt="estore-logo" src={`${process.env.PUBLIC_URL}/img/estore.png`} className="logo"/>
          </Box>
          <Box link={"https://wwwin.cisco.com/c/cec/employee.html"}>
            <img alt="employee-profile-logo" src={`${process.env.PUBLIC_URL}/img/employee-profile.png`} className="logo"/>
          </Box>
          <Box link={"http://wwwin.cisco.com/c/cec/employee/benefits-comps.html"}>
            <img alt="cisco-benefits-logo" src={`${process.env.PUBLIC_URL}/img/cisco-benefits.png`} className="logo"/>
          </Box>
          <Box link={"https://stock.cisco.com/EEC/"}>
            <img alt="employee-equity-center-logo" src={`${process.env.PUBLIC_URL}/img/employee-equity-center.png`} className="logo"/>
          </Box>
          <Box link={"http://wwwin.cisco.com/c/cec/employee/pto-payroll.html"}>
            <img alt="pto-payroll-logo" src={`${process.env.PUBLIC_URL}/img/pto-payroll.png`} className="logo"/>
          </Box>
          <Box link={"https://helpzone.cisco.com/"}>
            <img alt="help-zone-logo" src={`${process.env.PUBLIC_URL}/img/help-zone.png`} className="logo"/>
          </Box>
          <Box link={"http://atyourservice.cisco.com/"}>
            <img alt="at-your-service-logo" src={`${process.env.PUBLIC_URL}/img/at-your-service.png`} className="logo"/>
          </Box>
          <Box link={"http://concur.cisco.com/"}>
            <img alt="travel-expenses-logo" src={`${process.env.PUBLIC_URL}/img/sap-concur-travel-expenses.png`} className="logo"/>
          </Box>
          <Box link={"https://cisco.box.com/"}>
            <img alt="box-logo" src={`${process.env.PUBLIC_URL}/img/box.png`} className="logo"/>
          </Box>
          <Box link={"https://cs.co/mac-setup"}>
            <img alt="Mac Setup" src={`${process.env.PUBLIC_URL}/img/mac-setup.png`} className="logo"/>
          </Box>
          <Box link={"https://cs.co/win-setup"}>
            <img alt="Windows Setup" src={`${process.env.PUBLIC_URL}/img/windows-setup.png`} className="logo"/>
          </Box>
          <Box link={"https://mymobile.cisco.com/"}>
            <img alt="My Mobile Setup Help" src={`https://mymobile.cisco.com/static/media/estore_meraki.f0eae67f.svg`} className="logo1"/>
          </Box>
          <Box link={"https://smartbuy.cisco.com/home"}>
            <img alt="Smartbuy" src={`${process.env.PUBLIC_URL}/img/Smart_Buy_Icon_128.png`} className="logo"/>
          </Box>
        </div>
        <Particles 
          params={{
            particles: {
              number: {
                value: 50
              },
              shape: {
                type: 'polygon'
              },
              size: {
                value: 1.5
              },
              line_linked: {
                enable: false
              },
              opacity: {
                value: 0.1
              },
              move: {
                out_mode: 'out'
              },
            }
          }}
          height={'35%'}
          style={{
            position: 'absolute',
          }}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/frontend/component/main/App.js